import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from './messages/LicenseControls';

import LicenseActivationPanel from './LicenseActivationPanel';
import './styles/LicenseControls.scss';

import Button from '../../components/Button';
import { InputGroup, Label } from '../../components/Form';

const propTypes = {
  currentLicense: PropTypes.object,
  companyId: PropTypes.number.isRequired,
  licenseTypes: PropTypes.array,
  onActivation: PropTypes.func.isRequired,
  onDeactivation: PropTypes.func.isRequired,
  sellers: PropTypes.array,
  toggleActiveState: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const defaultProps = {
  currentLicense: null,
  licenseTypes: [],
  sellers: [],
};

class LicenseControls extends Component {
  constructor() {
    super();

    this.UI_STATE_ACTIVATION = 'activation';
    this.UI_STATE_DEACTIVATION = 'deactivation';
    this.UI_STATE_IDLE = 'idle';
    this.INITIAL_STATE = { uiState: this.UI_STATE_IDLE };
    this.state = this.INITIAL_STATE;
  }

  /* eslint-disable react/no-did-update-set-state */
  componentDidUpdate(prevProps) {
    if (this.props.companyId !== prevProps.companyId) {
      this.setState(this.INITIAL_STATE);
    }
  }
  /* eslint-enable react/no-did-update-set-state */

  onActivation = ({ license }) => {
    this.setState(
      { uiState: this.UI_STATE_IDLE },
      () => {
        this.props.toggleActiveState(false);
        this.props.onActivation({ license });
      }
    );
  }

  onDeactivation = () => {
    const { currentLicense: license } = this.props;
    this.setState(
      { uiState: this.UI_STATE_IDLE },
      () => {
        this.props.toggleActiveState(false);
        this.props.onDeactivation({ license });
      }
    );
  }

  toggleActivation = () => {
    if (this.state.uiState === this.UI_STATE_IDLE) {
      this.setState({ uiState: this.UI_STATE_ACTIVATION }, () => {
        this.props.toggleActiveState(true);
      });
    } else {
      this.setState({ uiState: this.UI_STATE_IDLE }, () => {
        this.props.toggleActiveState(false);
      });
    }
  }

  toggleDeactivation = () => {
    if (this.state.uiState === this.UI_STATE_IDLE) {
      this.setState({ uiState: this.UI_STATE_DEACTIVATION }, () => {
        this.props.toggleActiveState(true);
      });
    } else {
      this.setState({ uiState: this.UI_STATE_IDLE }, () => {
        this.props.toggleActiveState(false);
      });
    }
  }

  render = () => {
    const { currentLicense, licenseTypes, sellers, user } = this.props;
    const { uiState } = this.state;

    return (
      <div styleName='LicenseControls'>
        {uiState === this.UI_STATE_DEACTIVATION && (
          <React.Fragment>
            <InputGroup>
              <Label>
                <FormattedMessage {...messages.deactivationConfirmTitle} />
              </Label>
            </InputGroup>
            <InputGroup horizontal>
              <Button
                color='red'
                id="license-deactivation-confirm-yes-button"
                onClick={this.onDeactivation}
              >
                <FormattedMessage {...messages.deactivationConfirmYes} />
              </Button>
              <Button
                color='grey'
                id="license-deactivation-confirm-no-button"
                kind='tertiary'
                onClick={this.toggleDeactivation}
              >
                <FormattedMessage {...messages.deactivationConfirmNo} />
              </Button>
            </InputGroup>
          </React.Fragment>
        )}
        {uiState === this.UI_STATE_ACTIVATION && (
          <LicenseActivationPanel
            licenseTypes={licenseTypes}
            sellers={sellers}
            user={user}
            onActivate={this.onActivation}
            onCancel={this.toggleActivation}
            currentLicense={currentLicense}
            companyId={this.props.companyId}
          />
        )}
        {uiState === this.UI_STATE_IDLE && (
          <React.Fragment>
            <strong>
              <FormattedMessage {...messages.title} />
            </strong>
            <div styleName='padder' />
            {(currentLicense
              && currentLicense.toComparable('license.status') === 'pending'
            ) && (
              <React.Fragment>
                <FormattedMessage
                  {...messages.cantUpgradePendingWarning}
                />
                <div styleName='padder' />
              </React.Fragment>
            )}
            <div styleName='controls'>
              {!currentLicense && (
                <Button
                  id="license-activation-button"
                  onClick={this.toggleActivation}
                >
                  <FormattedMessage {...messages.activationButtonLabel} />
                </Button>
              )}
              {currentLicense && (
                <React.Fragment>
                  <Button
                    disabled={
                      currentLicense.toComparable('license.status')
                          === 'pending'
                    }
                    id="license-upgrade-button"
                    onClick={this.toggleActivation}
                  >
                    <FormattedMessage {...messages.upgradeButtonLabel} />
                  </Button>
                  <div styleName='padder' />
                  <Button
                    color='red'
                    id="license-deactivation-button"
                    onClick={this.toggleDeactivation}
                  >
                    <FormattedMessage {...messages.deactivationButtonLabel} />
                  </Button>
                </React.Fragment>
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
};

LicenseControls.propTypes = propTypes;
LicenseControls.defaultProps = defaultProps;

export default LicenseControls;
